import styled from 'styled-components';
import tokens from 'tokens';

export const Wrapper = styled.div`
  ${tokens.typography.note};
  color: red;
  margin-top: ${tokens.spacing.xs};
`;
